import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { EnvironmentService } from '../environment/environment.service';


export enum ScheduleFrequencyType {
  Once = 1,
  Daily = 4,
  Weekly = 8,
  Monthly = 16
}

export enum ScheduleDay {
  // tslint:disable-next-line:no-bitwise
  Sunday = 1,
  // tslint:disable-next-line:no-bitwise
  Monday = 2,
  // tslint:disable-next-line:no-bitwise
  Tuesday = 4,
  // tslint:disable-next-line:no-bitwise
  Wednesday = 8,
  // tslint:disable-next-line:no-bitwise
  Thursday = 16,
  // tslint:disable-next-line:no-bitwise
  Friday = 32,
  // tslint:disable-next-line:no-bitwise
  Saturday = 64
}

export enum ScheduleRunStatusType {
  running = 0,
  failed = 1,
  success = 2
}

export enum ScheduleSubDayType {
    AtSpecifiedTime = 1,
    Seconds = 2,
    Minutes = 4,
    Hours = 8
}

export class ConfigScheduleHistoryItem {
  historyId: number;
  configScheduleId: number;
  scheduleName: string;
  processStartDateTime: Date;
  processEndDateTime: Date;
  status: ScheduleRunStatusType;
  createdDateTime: Date;
  modifiedDateTime?: Date;
}

export class ConfigSchedule {
  id?: number;
  sqlScheduleId?: number;
  configId: number;
  configGuid: string;
  scheduleName: string;
  frequencyType: ScheduleFrequencyType;
  days: ScheduleDay;
  subDayType: ScheduleSubDayType;
  frequencySubDayType?: number;
  activeStartDate?: Date; // formatted as YYYYMMDD
  activeStartTime?: number; // HHMMSS on a 24-hour clock
  isRunning: boolean;
  retryAttempts?: number;
  retryInterval?: number;
}

export class DeleteConfigScheduleResponse {
  deleted: boolean;
  errorMessage?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SchedulerService {

  constructor(
    private httpClient: HttpClient,
    private environmentService: EnvironmentService) { }

  async upsertConfigSchedule(configSchedule: ConfigSchedule): Promise<ConfigSchedule> {
    //console.log('submitting new config schedule...');

    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Scheduler/upsertConfigSchedule`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const body = JSON.stringify(configSchedule);
    //console.log(body);
    const result = this.httpClient.post<ConfigSchedule>(requestUrl, body, { headers: headers});
    return result.toPromise();
  }

  async getAllConfigSchedules(): Promise<ConfigSchedule[]> {
    //console.log('getting all schedules...');

    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Scheduler/`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.get<ConfigSchedule[]>(requestUrl, { headers: headers});
    return result.toPromise();
  }

  async deleteConfigSchedule(configScheduleId: number): Promise<DeleteConfigScheduleResponse> {
    //console.log(`deleting schedule id: ${configScheduleId}...`);

    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Scheduler/deleteConfigSchedule/${configScheduleId}`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<DeleteConfigScheduleResponse>(requestUrl, { headers: headers});
    return result.toPromise();
  }

  async getAllConfigScheduleHistoryItems(): Promise<ConfigScheduleHistoryItem[]> {
    //console.log('getting config schedule history items...');
    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Scheduler/historyItems`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.get<ConfigScheduleHistoryItem[]>(requestUrl, { headers: headers});
    return result.toPromise();
  }
}
